import { render } from "./SetupMFA.vue?vue&type=template&id=5cb2cd24&scoped=true"
import script from "./SetupMFA.vue?vue&type=script&lang=js"
export * from "./SetupMFA.vue?vue&type=script&lang=js"

import "./SetupMFA.vue?vue&type=style&index=0&id=5cb2cd24&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cb2cd24"]])

export default __exports__